import React from "react";
import backgroundLandingImg from "../../../../assets/background-landing.png";

const AboutUsNavHeader = () => {
  return (
    <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat pt-16 pb-8 md:pt-20 md:pb-10 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[200px] sm:min-h-[100px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none" />

      <div className="relative max-w-[690px] mx-auto mt-[-2rem]">
        <div className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase text-white leading-[50px] mb-19 mt-8 leading-[32px] sm:leading-[25px] md:leading-[50px]">
          we change the way you do  restaurant and retail
        </div>

        <p className="mt-4 text-[#e0dfff] text-base md:text-lg font-normal max-w-[600px] mx-auto">
          we simplify the way you do restaurant and retail business
        </p>
      </div>

    </section>
  );
};

export default AboutUsNavHeader;
